module.exports = __webpack_public_path__ + "img/t2-21.1d0674db.svg";